import axios from "axios";
import {
  handleRequest,
  handleMultiRequest,
} from "@/store/utils/requestFunctions";
import * as endpoints from "@/store/constants/endpoints";
import * as types from "./mtypes";

export default {
  async getAllUserFields({ commit }) {
    await handleMultiRequest(
      commit,
      (params) =>
        axios.get(`${endpoints.USER_FIELDS}`, { params: { ...params } }),
      types.FETCH_USER_FIELDS_SUCCESS,
      types.REQUEST_FAILURE,
    );
  },

  async getUserFields({ commit }, params) {
    await handleRequest(
      commit,
      () => axios.get(`${endpoints.USER_FIELDS}${params}`),
      types.FETCH_USER_FIELDS_SUCCESS,
      types.REQUEST_FAILURE,
    );
  },

  async addUserField({ commit }, instance) {
    await handleRequest(
      commit,
      () => axios.post(`${endpoints.USER_FIELDS}`, instance),
      types.REQUEST_SUCCESS,
      types.REQUEST_FAILURE,
    );
  },

  async updateUserField({ commit }, instance) {
    await handleRequest(
      commit,
      () => axios.put(`${endpoints.USER_FIELDS}`, instance),
      types.REQUEST_SUCCESS,
      types.REQUEST_FAILURE,
    );
  },

  async updateFieldValue({ commit }, instance) {
    await handleRequest(
      commit,
      () => axios.put(`${endpoints.USER_FIELDS}/UpdateValue`, instance),
      types.REQUEST_SUCCESS,
      types.REQUEST_FAILURE,
    );
  },

  async AddFieldsToUser({ commit }, instance) {
    await handleRequest(
      commit,
      () => axios.put(`${endpoints.USERS}/Fields/add`, instance),
      types.REQUEST_SUCCESS,
      types.REQUEST_FAILURE,
    );
  },

  async RemoveFieldsToUser({ commit }, instance) {
    await handleRequest(
      commit,
      () => axios.put(`${endpoints.USERS}/Fields/remove`, instance),
      types.REQUEST_SUCCESS,
      types.REQUEST_FAILURE,
    );
  },
};
